// extracted by mini-css-extract-plugin
export var button = "edit-button-module--button--c52a8";
export var container = "edit-button-module--container--625db";
export var pencil = "edit-button-module--pencil--bf0c8";